jQuery(function($){

    $(window).load(function(){
        $('.page_preloader').delay(600).fadeOut(600);
    });

    $('html').removeClass('no-js'); 

    $('ul.styles > li').click(function(){
        var className = $(this).attr('class');
        $('body').removeClass('theme-style-0 theme-style-1 theme-style-2 theme-style-3');
        $('body').addClass(className);
      });


    /* placeholder js */
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });

    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });                    


    /* form validation */
    $('input.error, textarea.error').focus(function() {
      $(this).removeClass('error');
    });

    $('form :submit').click(function() {
      $(this).parents('form').find('input.hint, textarea.hint').each(function() {
        $(this).val('').removeClass('hint');
      });
      return true;
    });

   
    /* FORM STYLES */  
    $('.address_table form, .customer_address form').addClass('form-horizontal');


    /* ALERTS */
    $('.template-customers-login, #create_customer').find('.errors').addClass('alert').addClass('alert-danger');


	/* CUSTOM SELECTS */
    $('.header_currency select, #navigation select').styler();
    $('.jq-selectbox__trigger').append('<i class="fa fa-angle-down"></i>');


    /* MEGAMENU DESKTOP */
    $('.sf-menu').superfish({
        animation: {height: 'show'},
        speed: 'fast'
    });

    var path = window.location.pathname.split('/');
    path = path[path.length-1];
    if (path !== undefined) {
      $("ul.sf-menu > li").children("a[href$='" + path + "']").parents('li').children('a').addClass('active');
    };

    var path2 = window.location.pathname;
  	if (path2 == '/' || path == undefined) {
      $("ul.sf-menu > li").children("a[href$='" + path2 + "']").parents('li').children('a').addClass('active');
    };


    /* MEGAMENU MOBILE */
    $(document).ready(function(){
        $(".megamenu_mobile h2").click(function(){
            $(".submenu__1").slideToggle("slow");
            $(this).toggleClass("active");
        });

        $(".submenu__1 > li > a > i").click(function(){
            $(this).parent().parent().find(".submenu__2").slideToggle("slow");
            $(this).parent().toggleClass("active");
            return false;
        });

        $(".submenu__2 > li > a > i").click(function(){
            $(this).parent().parent().find(".submenu__3").slideToggle("slow");
            $(this).parent().toggleClass("active");
            return false;
        });

        $('.megamenu_mobile h2').on('click touchstart', function(e){
          	e.stopPropagation();
        });

        $(document).on('click', function(){
            $(".submenu__1").slideUp("slow");
            $(".megamenu_mobile").find("h2").removeClass("active");
        });
    });


    /* STICK MENU */
    $(document).ready(function(){
      	$('#megamenu').tmStickUp();
    });


    /* SCROLL ANIMATION */
    $(document).ready(function(){
        if (device.desktop() && !($.browser.msie && $.browser.version == 8.0) && $(window).width() >= 1200) {
            $('head').append('<link href="//yellowboxfireworks.com/cdn/shop/t/5/assets/animate.css?v=14094550577671592381776268975" rel="stylesheet" type="text/css" media="all" />');
            new WOW().init();
        };
    });


  	/* MAIN PRODUCT LISTING IMAGE CHANGE */
    $(document).ready(function(){
        if (device.desktop()) {
            $(".img_change").hover(function(){
                $(this).find(".img__2").stop().animate({"opacity": 1});
            },function(){
                $(this).find(".img__2").stop().animate({"opacity": 0});
            });
        };
    });


    /* SPLIT WORDS */
    $.fn.splitWords = function(index) {
        return this.each(function() {
            var el = $(this),
                i, first, words = el.text().split(/\s/);
            if (typeof index === 'number') {
                i = (index > 0) ? index : words.length + index;
            }
            else {
                i = Math.floor(words.length / 2);
            }
            first = words.splice(0, i);
            el.empty().
                append(makeWrapElem(1, first)).
                append(makeWrapElem(2, words));
        });
    };
    function makeWrapElem(i, wordList) {
        return $('<span class="wrap-' + i + '">' + wordList.join(' ') + ' </span>');
    }

    $('.split_words').splitWords(1);


    /* BRANDS ANIMATION */
    $(window).load(function(){
        $(".brands_item__1").attr("data-wow-delay", "0.4s");
        $(".brands_item__2").attr("data-wow-delay", "0.7s");
        $(".brands_item__3").attr("data-wow-delay", "0.5s");
        $(".brands_item__4").attr("data-wow-delay", "0.6s");
        $(".brands_item__5").attr("data-wow-delay", "0.8s");
        $(".brands_item__6").attr("data-wow-delay", "0.2s");

        $(".brands_item__7").attr("data-wow-delay", "0.6s");
        $(".brands_item__8").attr("data-wow-delay", "0.8s");
        $(".brands_item__9").attr("data-wow-delay", "0.3s");
        $(".brands_item__10").attr("data-wow-delay", "0.2s");
        $(".brands_item__11").attr("data-wow-delay", "0.7s");
        $(".brands_item__11").attr("data-wow-delay", "0.5s");
    });


    /* QR CODE POPOVERS - mobile click-to-toggle */
    $(document).ready(function () {
        $(document).on('click', '.js-qr-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $wrap = $(this).closest('.qr-wrap');
            var isOpen = $wrap.hasClass('qr-active');
            $('.qr-wrap').removeClass('qr-active');
            if (!isOpen) { $wrap.addClass('qr-active'); }
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.qr-wrap').length) {
                $('.qr-wrap').removeClass('qr-active');
            }
        });
    });


});